import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, View, Platform, ActivityIndicator, TouchableOpacity } from 'react-native';
import { Screen, Text, Button, Input } from '../components';
import { StringUtils } from '../utils';
import { HomePetsList } from '../containers';
import PetController from '../controllers/petController';
import AuthController from '../controllers/authController';
import UserController from '../controllers/userController';
import { useNavigate } from 'react-router-dom';

class SettingsChangePhoneNumberScreen_Base extends Component {

  constructor(props) {
    super(props);
    this.state = {
      display_section: 'view_phone_number' // view_phone_number, edit_phone_number, validate_code
    }

    this.update_phone_number = this.update_phone_number.bind(this);
    this.send_phone_code     = this.send_phone_code.bind(this);
    this.validate_phone_code = this.validate_phone_code.bind(this);
  }

  pull_user_phone_number = async () => {
    let user = await AuthController.getUser();

    if(user) {
      this.setState({
        phone_number: user.phone_number
      })
    }
  }

  async componentDidMount() {
    let user = await AuthController.getUser();

    if(user) {
      this.setState({
        phone_number: user.phone_number
      })
    }
  }

  update_phone_number(phone_number, phone_number_valid) {
    this.setState({
      phone_number,
      phone_number_valid
    })
  }

  async send_phone_code() {
    this.setState({loading: true}, async () => {
      let response = await AuthController.sendRegisterPhoneCode({phone: this.state.phone_number});

      if(response && response.success) {
        this.setState({ loading: false, display_section: 'validate_code', password_exists: response.passwordLogin })
      } else {
        this.setState({ phone_send_error: response.error, loading: false })
      }
    });
  }

  async validate_phone_code() {
    this.setState({loading: true}, async () => {
      let phone_number = this.state.phone_number;
      let code = this.state.validation_code;
      let response = await UserController.validatePhoneAndUpdate({phone_number, code});

      if(response && response.success) {
        this.goBack();
      } else {
        this.setState({ phone_verify_error: response.error, loading: false })
      }
    });
  }

  goBack = () => {
    if(Platform.OS === 'web') {
      this.props.navigate(-1);
    } else {
      this.props.navigation.goBack();
    }
  }

  render() {
    let editing = this.state.editing;
    let phone_number = this.state.phone_number;
        phone_number = StringUtils.displayCodePhoneNumber(phone_number);

    let valid = this.state.phone_number_valid;
    let phone_send_error = this.state.phone_send_error;
    let loading = this.state.loading;
    let phone_verify_error = this.state.phone_verify_error;

    let display_section = this.state.display_section;

    let label_text = !phone_number ? 'No Phone Number Added' : 'Current Phone Number';
    let button_lbl = !phone_number ? 'Add Phone Number' : 'Edit';

    return (
      <Screen navigation={this.props.navigation} title={'Change Phone Number'} auth={true} auth_success={ () => { this.pull_user_phone_number() }}>
        <View style={{ padding: 20 }}>

          {display_section === 'view_phone_number' ?
            <>
              <View style={{ alignItems: 'center' }}>
                <Text style={{ fontSize: 22, color: '#040415' }}>{ phone_number }</Text>
                <Text style={{ fontSize: 16, color: '#575762', marginTop: 3 }}>{ label_text }</Text>
              </View>
              <Button title={ button_lbl }
                style={{ marginTop: 20 }}
                onPress={()=>{this.setState({display_section: 'edit_phone_number'})}}/>
            </> : null }

          {display_section === 'edit_phone_number' ?
            <>
              <View style={{ alignItems: 'center' }}>
                <Input type="phone"
                       onChangeText={this.update_phone_number} />
              </View>
              {phone_send_error ? <Text style={styles.error_message}>{phone_send_error}</Text> : null}
              <Button title='Send Code'
                loading={loading}
                style={{ marginTop: 20 }}
                inactive={!valid}
                onPress={this.send_phone_code}/>
            </> : null }

          {display_section === 'validate_code' ?
          <View style={{ alignItems: 'center' }}>
            <View style={{ height: 110, width: 330, marginTop: 80 }}>
              <Text style={{ fontSize: 32, fontWeight: 'bold', textAlign: 'center' }}>Validation Code</Text>
              <Text style={{ fontSize: 16, color: '#575762', textAlign: 'center' }}>We’ve texted you a validation code</Text>
            </View>

            <Input placeholder='Code'
                  style={{ marginBottom: 30, width: 100, textAlign: 'center' }}
                  onChangeText={ (code) => {
                    this.setState({ ...this.state, validation_code: code });
                  }}/>
            {phone_verify_error ? <Text style={styles.error_message}>{this.state.phone_verify_error}</Text> : null}
            <Button title='Validate'
                    loading={loading}
                    style={{ width: 200, marginBottom: 10, }}
                    onPress={ this.validate_phone_code }/>
          </View> : null }
        </View>
      </Screen>
    );
  }
}

function SettingsChangePhoneNumberScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();

    return  <SettingsChangePhoneNumberScreen_Base {...props} navigate={navigate} />
  } else {
    return  <SettingsChangePhoneNumberScreen_Base {...props} navigate={props.navigation.push} />
  }
}

const styles = StyleSheet.create({

});

export default SettingsChangePhoneNumberScreen
